import { AxiosError } from 'axios';
import { capitalize } from 'lodash-es';

import { UI_TEXT } from '../constants';
import { AuthStatus as AuthStatusType, BaseAuthParams } from '../types';

import { ManualRetryButton } from './ManualRetryButton';

interface AuthStatusProps extends AuthStatusType {
  baseParams?: BaseAuthParams;
  finalMeetingUrl?: string;
}

export const AuthStatus = ({
  isError,
  isSuccess,
  error,
  canManualRetry,
  baseParams,
  finalMeetingUrl,
}: AuthStatusProps) => {
  const renderStatusMessage = () => {
    if (isError) {
      if (error instanceof AxiosError) {
        const axiosError = error as AxiosError<{ title?: string; detail?: string }>;
        if ((axiosError.response?.status ?? 0) >= 500) {
          return 'Please try again. If the issue persists, close this window and click Login again.';
        }
        return `${axiosError.response?.data?.title ?? ''} ${axiosError.response?.data?.detail ?? ''}`.trim() || UI_TEXT.FAILED_FALLBACK;
      }
      return UI_TEXT.FAILED_FALLBACK;
    }

    return isSuccess ? UI_TEXT.SUCCESS : UI_TEXT.LOADING;
  };

  const renderRedirectMessage = () => {
    if (!isSuccess) return null;

    return (
      <div className="text-lg text-gray-black">
        {finalMeetingUrl && baseParams?.platform ? (
          <>
            {UI_TEXT.REDIRECTING_PREFIX} {capitalize(baseParams.platform)}{' '}
            {UI_TEXT.REDIRECTING_SUFFIX}
          </>
        ) : (
          <>{UI_TEXT.CLOSE_MESSAGE}</>
        )}
      </div>
    );
  };

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-24">
      <div className="text-2xl text-gray-black">
        {renderStatusMessage()}
      </div>

      {renderRedirectMessage()}

      {isError && canManualRetry && <ManualRetryButton />}
    </div>
  );
};
